<template>
  <div>
    <div style="height: 30px;">&nbsp;&nbsp;</div>
    <!-- :default-active="$store.state.la"-->
    <el-menu
      class="el-menu-vertical-demo"
      active-text-color="#3370FF"
      @select="handleSelect"
      :default-active="da2"
    >
      <!-- <el-menu-item :index="item.path" v-for="item in data" v-bind:key="item.id">
        <i :class="item.icon"></i>
        <span slot="title">{{item.name}}</span>
      </el-menu-item>-->

      <template v-for="(item,index) in data">
        <el-menu-item
          :index="item.path"
          v-bind:key="item.id"
          v-if="item.path"
        >
          <i :class="item.icon"></i>
          <span slot="title">{{item.name}}</span>
        </el-menu-item>

        <el-submenu
          :index="''+index"
          :key="item.id"
          v-else
        >
          <template slot="title">
            <i :class="item.icon"></i>
            <span slot="title">{{item.name}}</span>
          </template>
          <el-menu-item
            :index="subItem.path"
            v-for="subItem in item.children"
            v-bind:key="subItem.id"
          >
            <i :class="subItem.icon"></i>
            <span slot="title">{{subItem.name}}</span>
          </el-menu-item>
        </el-submenu>
      </template>
    </el-menu>
  </div>
</template>

<script>
import { mapState } from "vuex";
import _ from "lodash";

const w = {
  props: ["data"],
  data() {
    return {
      da: "",
    };
  },
  computed: {
    ...mapState({
      da2: (state) => state.la,
    }),
  },
  methods: {
    handleSelect(key, keyPath) {
      this.$router.push("/" + key);
    },
  },
  created() {},
  updated() {},
  mounted() {},
};
export default w;
</script>
<style scoped>
.el-menu-vertical-demo {
  background-color: #f5f5f5;
}

.el-menu-item {
  color: #333;
}
</style>
